import { render, staticRenderFns } from "./NormalSearchNav157.vue?vue&type=template&id=56fa6521&scoped=true&"
import script from "./NormalSearchNav157.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav157.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa6521",
  null
  
)

export default component.exports